import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/security/twoFactorRecoveryCodes';
import { clear as clearEnable } from '../../actions/security/twoFactorEnable';
import { fetchRequest as fetchStatus } from '../../actions/security/twoFactorStatus';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation(action) {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/user/2fa/recovery-codes`,
      { code: action.payload.code },
      { headers: getLocalUser() },
    );
    const codes = unwrap(res).recovery_codes || [];
    // The fresh set replaces whatever the enable step left on screen.
    yield put(clearEnable());
    yield put({
      type: 'SHOW_SUCCESS_SNACKBAR',
      message: 'New recovery codes generated — the old ones no longer work',
    });
    yield put(fetchStatus());
    yield put(fetchSuccess({ recovery_codes: codes }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.data?.message
      || err?.response?.data?.message
      || 'That code didn\'t work';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
